module.exports = __webpack_public_path__ + "img/rotten_cucumber.e8fddc09.png";